// Session storage — hashSiteId, apiKey, settings only. Never access_token.

export const STORAGE_KEYS = {
  HASH_SITE_ID: 'backuply_hash_site_id',
  API_KEY: 'backuply_api_key',
  SETTINGS: 'backuply_settings',
  SESSION_TIMESTAMP: 'backuply_session_ts',
  EMBED_CONTEXT: 'backuply_embed_context',
};

export const SESSION_DURATION = 24 * 60 * 60 * 1000;

export function clearAllStorage() {
  sessionStorage.removeItem(STORAGE_KEYS.HASH_SITE_ID);
  sessionStorage.removeItem(STORAGE_KEYS.API_KEY);
  sessionStorage.removeItem(STORAGE_KEYS.SETTINGS);
  sessionStorage.removeItem(STORAGE_KEYS.EMBED_CONTEXT);
  localStorage.removeItem(STORAGE_KEYS.SESSION_TIMESTAMP);
}

export function clearExpiredSession() {
  clearAllStorage();
}

export function initializeSession() {
  localStorage.setItem(STORAGE_KEYS.SESSION_TIMESTAMP, Date.now().toString());
}

export function isSessionValid() {
  const ts = localStorage.getItem(STORAGE_KEYS.SESSION_TIMESTAMP);
  if (!ts) return false;
  return Date.now() - parseInt(ts, 10) <= SESSION_DURATION;
}

export function validateSession() {
  if (!isSessionValid()) {
    clearExpiredSession();
    return false;
  }
  return true;
}

export function getHashSiteId() {
  return sessionStorage.getItem(STORAGE_KEYS.HASH_SITE_ID);
}

/** Alias used by MainApp / Upgrade */
export function getStoreId() {
  return getHashSiteId();
}

export function setHashSiteId(id) {
  if (id) sessionStorage.setItem(STORAGE_KEYS.HASH_SITE_ID, id);
}

export function setStoreId(id) {
  setHashSiteId(id);
}

export function getApiKey() {
  return sessionStorage.getItem(STORAGE_KEYS.API_KEY);
}

export function setApiKey(apiKey) {
  if (apiKey) sessionStorage.setItem(STORAGE_KEYS.API_KEY, apiKey);
}

export function getSettings() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEYS.SETTINGS);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSettings(settings) {
  if (settings) sessionStorage.setItem(STORAGE_KEYS.SETTINGS, JSON.stringify(settings));
}

export function getEmbedContext() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEYS.EMBED_CONTEXT);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setEmbedContext(context) {
  if (context && Object.keys(context).length > 0) {
    sessionStorage.setItem(STORAGE_KEYS.EMBED_CONTEXT, JSON.stringify(context));
  } else {
    sessionStorage.removeItem(STORAGE_KEYS.EMBED_CONTEXT);
  }
}
